<template>
  <div :class="{fit, 'base-page-template': true}" :style="rootStyle">
    <portal to="app-header" :order="1" v-if="hasToolbarItems">
      <v-toolbar dense flat tile class="base-toolbar" @click="handleToolbarClick">
        <back-button v-if="!isNested" :to="backButtonTo"></back-button>
        <slot name="toolbar-items"></slot>
      </v-toolbar>
    </portal>

    <slot name="prepend"></slot>
    <slot></slot>
    <slot name="append"></slot>
  </div>
</template>

<script>
import BackButton from "@/components/atoms/BackButton.vue";

const basePageTemplateSymbol = Symbol('BasePageTemplate');

export default {
  name: "BasePageTemplate",
  components: { BackButton },
  props: {
    fit: {
      type: Boolean,
      default: false
    }
  },
  inject: [
    'mainPadding',
    'mainScroll'
  ],
  data() {
    return {
      basePageTemplateSymbol,
    };
  },
  computed: {
    rootStyle() {
      if(this.fit) {
        return {
          position: 'absolute',
          left: 0,
          right: 0,
          top: `calc(${this.mainPadding.top} - 8px)`, // 8px = class="pt-2 base-page-template" in App.vue
          bottom: this.mainPadding.bottom,
        };
      } else {
        return {};
      }
    },
    hasToolbarItems() {
      return !!this.$slots['toolbar-items']?.length;
    },
    isNested() {
      let current = this.$parent;
      do {
        if(current.basePageTemplateSymbol === basePageTemplateSymbol) {
          return true
        }
        current = current.$parent;
      } while(current)
      return false;
    },
    backButtonTo() {
      let current = this.$parent;
      do {
        const result = current.backButtonTo;
        if(result) {
          return result;
        }
        current = current.$parent;
      } while(current);
      return null;
    }
  },
  methods: {
    handleToolbarClick(e) {
      const target = e.target, classes = target.classList;
      const {mainScroll: scroll} = this;
      const {y, height, moveTo} = scroll;
      if(classes.contains('v-toolbar__content')
          || classes.contains('v-toolbar__title')
          || classes.contains('spacer')) {
        moveTo({top: Math.min(y, height - 32), behavior: 'instant'});
        moveTo({top: 0});
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.base-page-template {
  display: flex;
  flex-direction: column;

  &.fit {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}

.v-toolbar.base-toolbar {
  flex-grow: 1;
  background-color: transparent;
  overflow: visible;

  ::v-deep .v-toolbar__title {
    cursor: default;
    min-width: fit-content;
  }
}
</style>
